(function () {
  const pushFormKey = (ev) => {
    ev.preventDefault()

    // TODO: get form key from passed in function overload instead of hardcoding it like this
    const form_key = "eyJkb21haW4iOiJ0cnlhdXRvYnJ1c2gzIiwiZm9ybV9pZCI6ImVkOTU0Yzk4LTgzN2EtNDQwNS1iZGUxLTk5ZmVkMTg5YWI4OSJ9"

    // // I can see the response in the devtools but no-cors opaque response makes it unusable on the code end
    // fetch(`https://sendlane.com/form-api/form/${form_key}`, { mode: 'no-cors' })
    //   .then(res => res.json())
    //   .then(json => {
    //     console.log(json) // empty string
    //   })

    // This works, but I can't get to the received data this way
    window._Sendlane = window._Sendlane || [];
    _Sendlane.push({ form_key });
  }

  document.querySelectorAll('.waitlist_pro, button.cta-to-waitlist').forEach(function (element) {
    element.addEventListener('click', pushFormKey);
  })

})()